module.exports = __webpack_public_path__ + "media/images/edit-pen-67ef4b74a38df2217ce8bc6b4002ee3d.svg";